import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaCog, FaUsers, FaFileInvoiceDollar, FaFileContract, FaHandshake, FaFileMedical, FaUniversity, FaChartLine, FaMoneyCheckAlt, FaFileCsv } from 'react-icons/fa';
import '../../styles/pages/RRHH/RRHHPage.css';

/**
 * Página principal del módulo de Recursos Humanos
 * Muestra menú con todas las opciones del módulo
 */
const RRHHPage = ({ id_company }) => {
    const navigate = useNavigate();

    const menuItems = [
        {
            title: 'Parámetros Empresa',
            description: 'Configuración de parámetros de RRHH',
            icon: <FaCog />,
            path: '/rrhh/parametros',
            color: '#3498db'
        },
        {
            title: 'Colaboradores',
            description: 'Gestión de empleados y trabajadores',
            icon: <FaUsers />,
            path: '/rrhh/colaboradores',
            color: '#2ecc71'
        },
        {
            title: 'Liquidaciones de Sueldo',
            description: 'Liquidaciones mensuales de remuneraciones',
            icon: <FaFileInvoiceDollar />,
            path: '/rrhh/liquidaciones',
            color: '#f39c12'
        },
        {
            title: 'Previred',
            description: 'Declaraciones y archivos Previred',
            icon: <FaUniversity />,
            path: '/rrhh/previred',
            color: '#9b59b6'
        },
        {
            title: 'Indicadores Previsionales',
            description: 'Indicadores Previred mensuales',
            icon: <FaChartLine />,
            path: '/rrhh/indicadores-previred',
            color: '#16a085'
        },
        {
            title: 'Contratos',
            description: 'Contratos de trabajo',
            icon: <FaFileContract />,
            path: '/rrhh/contratos',
            color: '#e74c3c'
        },
        {
            title: 'Finiquitos',
            description: 'Finiquitos de término de contrato',
            icon: <FaHandshake />,
            path: '/rrhh/finiquitos',
            color: '#34495e'
        },
        {
            title: 'Licencias Médicas',
            description: 'Gestión de licencias médicas',
            icon: <FaFileMedical />,
            path: '/rrhh/licencias-medicas',
            color: '#1abc9c'
        },
        {
            title: 'Retención Honorarios',
            description: 'Boletas de honorarios de terceros',
            icon: <FaMoneyCheckAlt />,
            path: '/rrhh/retencion-honorarios',
            color: '#c0392b'
        },
        {
            title: 'DT - Archivos CSV',
            description: 'Generación de archivos CSV para la DT',
            icon: <FaFileCsv />,
            path: '/rrhh/dt',
            color: '#00796B'
        }
    ];

    return (
        <div className="rrhh-container">
            <div className="rrhh-header">
                <h1>Recursos Humanos</h1>
                <p>Gestión integral de personal y remuneraciones</p>
            </div>

            <div className="rrhh-menu-grid">
                {menuItems.map((item, index) => (
                    <div
                        key={index}
                        className="rrhh-menu-card"
                        onClick={() => navigate(item.path)}
                        style={{ borderColor: item.color }}
                    >
                        <div className="rrhh-card-icon" style={{ color: item.color }}>
                            {item.icon}
                        </div>
                        <h3>{item.title}</h3>
                        <p>{item.description}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default RRHHPage;
